import { Modal, Title, Text, Stack, List } from '@mantine/core';

export const PrivacyPopup = ({ opened, onClose }: { opened: boolean; onClose: () => void }) => {
  return (
    <Modal opened={opened} onClose={onClose} title={<Title>Privacy Policy</Title>} size="lg">
      <Stack px="lg">
        <Text>Last updated: {new Date().toLocaleDateString()}</Text>

        <Title order={4}>1. Information We Collect</Title>
        <Text>We collect information that you provide directly to us. This includes:</Text>
        <List>
          <List.Item>
            Account Information: We collect your wallet address, username, and optional information such as email, bio,
            and profile image when you create an account.
          </List.Item>
          <List.Item>
            Social Information: We may collect your Telegram, Discord, Farcaster, and Google handles if you provide
            them.
          </List.Item>
          <List.Item>
            Usage Information: We collect information about your activity on the service, such as threads you create or
            participate in.
          </List.Item>
        </List>

        <Title order={4}>2. How We Use Your Information</Title>
        <Text>We use the information we collect to:</Text>
        <List>
          <List.Item>Provide, maintain, and improve our services.</List.Item>
          <List.Item>Personalize your experience.</List.Item>
          <List.Item>Communicate with you about products, services, offers, and events.</List.Item>
          <List.Item>Monitor and analyze trends, usage, and activities in connection with our services.</List.Item>
        </List>

        <Title order={4}>3. How We Share Your Information</Title>
        <Text>
          We do not share your personal information with third parties except as described in this Privacy Policy. We
          may share your information with your consent, for legal reasons, or with service providers who are
          contractually obligated to protect your information.
        </Text>

        <Title order={4}>4. Data Retention</Title>
        <Text>
          We store the information we collect about you for as long as is necessary for the purpose(s) for which we
          originally collected it. We may retain certain information for legitimate business purposes or as required by
          law.
        </Text>

        <Title order={4}>5. Your Choices</Title>
        <Text>You may update, correct, or delete information about you at any time by logging into your account.</Text>

        <Title order={4}>6. Contact Us</Title>
        <Text>If you have any questions about this Privacy Policy, please contact us.</Text>
      </Stack>
    </Modal>
  );
};
